import React from 'react';
import PropTypes from 'prop-types';
import { TableCell } from '@material-ui/core';
import { defaultMyTableHeadCellPropTypes } from './my-table-prop-types';


const MyTableRowCell = ({ children, padding, align }) => (
  <TableCell
    padding={padding ? 'default' : 'none'}
    align={align}
  >
    {children}
  </TableCell>
);

MyTableRowCell.propTypes = {
  children: PropTypes.node.isRequired,
  padding: PropTypes.bool,
  align: PropTypes.string,
};

MyTableRowCell.defaultProps = defaultMyTableHeadCellPropTypes;

export default MyTableRowCell;
